import React, { useEffect, useRef, useState } from 'react';
import TagButton from '../../home-page/home-page-widgets/TagButton';
import { useProductsByParam } from '@/hooks/useProducts';
import ProductGridGlobal from '@/components/widgets/ProductGridGlobal';
import Loading from '@/components/widgets/Loading';
import { useUser } from '@/components/widgets/UserProvider';
import { useRouter } from 'next/navigation';
import ButtonWithArrow from '../../home-page/home-page-widgets/ButtonWithArrow';
import { FetchProductParams } from '@/helpers/types/params_body/FetchProductParams';
import { formatToAED, formatToINR, formatToUSD } from '@/helpers/formatToINR'
import { useCurrency } from '@/components/widgets/CurrencyProvider';

const JewelryShowcase = () => {
  const router = useRouter();
  const [currentSlide, setCurrentSlide] = useState(0);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const { userPageLoading } = useUser();
  const [mobileProducts, setMobileProducts] = useState<any>([])
  const { currency } = useCurrency();

  // const {
  //   data: productList,
  //   isLoading,
  //   error,
  // } = useProductsPlacement('home-page-essential-look')

  const params: FetchProductParams = {
    // main_category: 'Rings',
    subcategory: 'VERI',
    karat:"10"
  };

  const { products: productList, isLoading, isError } = useProductsByParam(params);

  useEffect(() => {
    if (!isLoading && productList?.length) {
      setMobileProducts(productList)
    }
  },[isLoading,productList])

  const handleMouseDown = (e: React.MouseEvent) => {
    setIsDragging(true);
    setStartX(e.pageX - (scrollContainerRef.current?.offsetLeft || 0));
    setScrollLeft(scrollContainerRef.current?.scrollLeft || 0);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseMove = (e: React.MouseEvent) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - (scrollContainerRef.current?.offsetLeft || 0);
    const walk = (x - startX) * 2;
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollLeft = scrollLeft - walk;
    }
  };

  const prevSlide = () => {
    setCurrentSlide((current) =>
      current === 0 ? mobileProducts.length - 1 : current - 1
    );
  };

  const nextSlide = () => {
    setCurrentSlide((current) =>
      current === mobileProducts.length - 1 ? 0 : current + 1
    );
  };

  const getFormattedPrices = (product: any) => {
    if (!product) return { sp: '', mrp: '' };

    let sp = '';
    let mrp = '';

    if (currency === 'AED') {
      sp = formatToAED(+product?.dirhams_mrp);
      mrp = formatToAED(+product?.dirhams_mrp);
    } else if (currency === 'USD') {
      sp = formatToUSD(+product?.dollar_mrp);
      mrp = formatToUSD(+product?.dollar_mrp);
    } else {
      sp = formatToINR(+product?.sp);
      mrp = formatToINR(+product?.mrp);
    }

    return { sp, mrp };
  };
  const { sp, mrp } = getFormattedPrices(mobileProducts[currentSlide]);

  const getArrowImage = (direction: 'left' | 'right') => {
    if (direction === 'left') {
      return currentSlide === 0
        ? {
            src: '/engagement/jwelry_showcase/arrow_gray_left.png',
            rotate: false,
          }
        : {
            src: '/engagement/jwelry_showcase/arrow_white_right.png',
            rotate: true,
          };
    } else {
      return currentSlide === mobileProducts.length - 1
        ? {
            src: '/engagement/jwelry_showcase/arrow_gray_left.png',
            rotate: true,
          }
        : {
            src: '/engagement/jwelry_showcase/arrow_white_right.png',
            rotate: false,
          };
    }
  };

  return (
    <div className='bg-black'>
      {/* Mobile view */}
      <div className='md:hidden flex flex-col'>
        <div className='w-full relative group cursor-pointer h-[410px]'>
          <div className='relative h-full overflow-hidden'>
            <div className='absolute inset-0'>
              <img
                src='https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/Engagement_Page/jwelry_showcase/designer_ring.webp'
                alt='Discover our'
                className='w-full h-full object-cover sm:scale-[1.9] scale-[1.2] transition-transform duration-300'
                style={{
                  objectPosition: 'center top',
                  transformOrigin: '22% 140%',
                }}
              />
            </div>
          </div>
          <div className='absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black via-black/80 to-transparent h-52 -mb-4 z-10'>
            <div className='absolute bottom-10 left-0 right-0 text-center'>
              <h2 className='font-psNormal text-[14px] tracking-[0.1em] text-white uppercase'>
                Discover our
              </h2>
              <p className='font-cambonRegular text-[24px] text-white'>
                Designer
                <span className='italic'> Ring</span>
              </p>
            </div>
          </div>
        </div>
        {isLoading ? (
          <Loading
            classes={
              'flex-grow flex relative max-h-screen sm:min-h-[645px] bg-[rgba(128,128,128,0.3)] !text-white'
            }
          />
        ) : (
          <div className='w-full relative h-[494px]'>
            <div className='flex items-center gap-4 px-2 h-full'>
              <button
                onClick={prevSlide}
                className='z-10'
                disabled={currentSlide === 0}
              >
                <img
                  src={getArrowImage('left').src}
                  alt='Previous'
                  className={`w-6 h-6 object-contain ${
                    getArrowImage('left').rotate ? 'rotate-180' : ''
                  }`}
                />
              </button>

              <div className='relative flex-1 h-full'>
                <div className='w-full h-full flex flex-col items-center justify-center bg-black'>
                  <img
                    src={
                      mobileProducts[currentSlide]?.image_url_list[0]?.url
                    }
                    alt='Center Image'
                    className='w-auto object-contain h-[250px] scale-[1.4]'
                  />
                  <div className='text-center mt-[60px]'>
                    <h3 className='uppercase font-barlowRegular text-white text-[12px] tracking-[0.1em] mb-1'>
                      {productList[currentSlide]?.name}{' '}
                    </h3>
                    <h3 className='font-cambonLight text-[9px] tracking-[0.1em] mb-1 text-[#E6DB96] mx-6'>
                      Precision crafted, the Chelsea Bezel Solitaire Ring
                      embodies sleek, artful design.
                    </h3>
                    <div className='font-cambonRegular text-[16px] text-center text-[#fff]'>
                      {/* {formatToINR(+mobileProducts[currentSlide]?.mrp)} */}
                      {/* {currencyType==='AED' ?formatToAED(+mobileProducts[currentSlide]?.dirhams_mrp):currencyType==='USD'?formatToUSD(+mobileProducts[currentSlide]?.dollar_mrp):formatToINR(+mobileProducts[currentSlide]?.mrp)} */}
                         <span>{mrp}</span>
                          {sp !== mrp && (
                            <span className='ml-2 line-through opacity-60'>
                              {sp}
                            </span>
                          )}
                    </div>
                  </div>
                  <div>
                    <div className='self-left mt-2'>
                      <ButtonWithArrow
                        minSize={14}
                        title={'Shop Seattle Ring'}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <button
                onClick={nextSlide}
                className='z-10'
                disabled={currentSlide === mobileProducts.length - 1}
              >
                <img
                  src={getArrowImage('right').src}
                  alt='Next'
                  className={`w-6 h-6 object-contain ${
                    getArrowImage('right').rotate ? 'rotate-180' : ''
                  }`}
                />
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Desktop view            */}
      <div className='hidden md:flex flex-row w-full'>
        {userPageLoading ? (
          <Loading
            classes={
              'flex-grow flex relative max-h-screen sm:min-h-[645px] bg-[rgba(128,128,128,0.3)] !text-white'
            }
          />
        ) : (
          <div className='w-[47.5%] max-w-[658px] min-w-[600px] relative group cursor-pointer h-[750px] select-none pr-[18px]'>
            <div className='relative h-full w-full'>
              <div className='absolute inset-0 w-full h-full'>
                <img
                  src='/engagement/engagement_designer_ring.png'
                  alt='Discover our'
                  className='h-full w-auto scaled-[1.7] object-cover'
                />
              </div>
            </div>
            <div className='absolute bottom-0 left-0 right-0 pb-[48px] pl-6 bg-gradient-to-t from-black/90 to-transparent text-white '>
              <div className='text-left'>
                <h2 className='font-psNormal text-[14px] tracking-[0.2em] select-none leading-tight uppercase'>
                  Discover our
                </h2>
                <p className='font-cambonLight text-[64px] select-none leading-tight '>
                  Designer <span className=' font-cambonLightItalic'>Ring</span>
                </p>

                <div className='flex pb-12 mt-3'>
                  <TagButton
                    text='SEE ALL RINGS'
                    onClick={() => {
                      router.push(
                        `/product-listing?subcategory=Designer&main_category=Rings`
                      );
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        <div className='lg:w-[65%] w-[52.5%] min-w-0 flex-1'>
          <ProductGridGlobal
            productList={
              productList
                ?.filter((item, index) => index % 2 !== 0)
                .slice(0, 10) ?? []
            }
            className='h-full w-full'
            gridClassName=''
            withScroll={true}
            cardClassName='max-w-[320px] w-full flex-shrink-0 '
            mediaClassName='max-h-[450px] h-full max-w-[320px] w-full'
            descriptionClassName='text-white hidden'
            titleClassName='uppercase text-[24px] leading-[32px] font-[500]'
            priceClassName='font-cambonRegular text-[#A08260] text-[32px] leading-[41.92px]'
            desktopConfig={{
              slidesPerView: 2.5,
              spaceBetween: 16,
            }}
            mobileConfig={{
              slidesPerView: 1.2,
              spaceBetween: 10,
            }}
            ctaConfig={{
              text: 'Shop Designer Ring',
              isEnable: true,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default JewelryShowcase;
